import React from 'react';

import serverApi from '../../utils/serverApi.js';

/**
 * A higher ticket component wrapper that adds a change request to a ticket.
 *
 * @param {Object} WrappedComponent
 * @returns {Object}
 */
export default function ticketUpdateByIdHOC(WrappedComponent) {
  /**
   * The TicketUpdateById higher ticket component.
   */
  class TicketUpdateById extends React.Component {
    /**
     * @constructor
     * @param {{}} props
     * @param {{}} componentContext
     */
    constructor(props, componentContext) {
      super(props, componentContext);

      this.state = {
        ticketId: null,
        isLoading: false,
        success: null,
        error: null,
      };
    }

    /**
     * Adds a change request to the ticket.
     *
     * @param {number} ticketId
     * @param {string} changeRequest
     */
    updateTicket = (ticketId, changeRequest) => {
      this.setState({
        ticketId,
        isLoading: true,
        success: null,
        error: null,
      }, () => {
        serverApi.ticketUpdateById(ticketId, changeRequest).then((response) => {
          this.setState({
            isLoading: false,
            success: this.mapResponse(response),
            error: null,
          });
        }, (error) => {
          this.setState({
            isLoading: false,
            ticket: null,
            success: false,
            error,
          });
        });
      });
    };

    /**
     * Maps the Axios response to the ticket data.
     *
     * @param {{data: object}} response
     * @returns {object|null}
     */
    mapResponse = (response) => {
      if (!response || !response.data) {
        return null;
      }

      return response.data.success;
    };

    /**
     * Renders the WrappedComponent.
     *
     * @returns {Object}
     */
    render() {
      const newProps = {
        ticketUpdateById: {
          updateTicket: this.updateTicket,
          isLoading: this.state.isLoading || false,
          success: this.state.success || null,
          error: this.state.error,
        }
      };

      return <WrappedComponent {...this.props} {...newProps} />
    }
  }

  TicketUpdateById.propTypes = {};

  return TicketUpdateById;
}



// WEBPACK FOOTER //
// ./src/components/hoc/ticketUpdateByIdHoc.js